import { styled } from '../../../../modules';

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: #ffffff;
    overflow-y: auto;
    padding: 32px 24px 24px;
`;

export const TopSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 28px;
`;

export const LogoContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

export const LogoImage = styled.img`
    max-height: 52px;
    max-width: 180px;
    object-fit: contain;
`;

export const IntroSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
    text-align: center;
`;

export const Title = styled.h1<{ $color: string }>`
    font-size: 22px;
    font-weight: 400;
    color: ${({ $color }) => $color ?? '#0e3573'};
    margin: 0;
    line-height: 1.35;
    text-align: center;

    strong {
        font-weight: 800;
    }
`;

export const Subtitle = styled.p`
    font-size: 14px;
    font-weight: 400;
    color: #555;
    margin: 0;
    text-align: center;
`;

export const FormSection = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 20px;
`;

export const FormFieldsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const CheckboxGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const Footer = styled.footer`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 16px;
`;
